import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'pcln-design-system'

const ChangeSearchSubmitButton = ({ submitSearch }) => (
  <Button color='secondary' width={1} onClick={submitSearch}>
    Search
  </Button>
)

ChangeSearchSubmitButton.propTypes = {
  submitSearch: PropTypes.func,
}

export { ChangeSearchSubmitButton }
